import FormHeader from 'components/Form/FormHeader';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import {FC} from 'react';
import {c} from 'ttag';

import Section from './Section';

const ViewFavouriteTemplatePage: FC = () => {
    return (
        <div>
            <NavigationTabs.DocumentSettings selection="favouriteTemplate" />
            <FormHeader
                link={{
                    href: window.Urls.favourite_template_edit(),
                    icon: 'edit',
                    kind: 'secondary',
                    label: c('component').t`Edit`,
                }}
                subtitle={c('component')
                    .t`Select and order the Templates that appear at the top of the Document Template picker.`}
                title={c('component').t`Favorite Templates`}
            />
            <Section />
        </div>
    );
};

export default ViewFavouriteTemplatePage;
